import { render, staticRenderFns } from "./userDraw.vue?vue&type=template&id=636f6462&scoped=true&"
import script from "./userDraw.vue?vue&type=script&lang=js&"
export * from "./userDraw.vue?vue&type=script&lang=js&"
import style0 from "./userDraw.vue?vue&type=style&index=0&id=636f6462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f6462",
  null
  
)

export default component.exports